/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : CommonLoader.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : CommonLoader component
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Jan 28th, 2022
 *
 * @Version      : Version 1.0
 *
 * By            : <Changed By user id>
 * On            :  <Change Date>
 * Description   : <Change Description>
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Card, Loader } from "@scuf/common";
import "./CommonLoader.scss";

export const CommonLoader: FC = () => {
  return (
    <div className="common-loader-position">
      <Card>
        <Card.Content>
          <Loader minHeight={100} data-testid="common-loader">
            <div className="placeholder" />
          </Loader>
        </Card.Content>
      </Card>
    </div>
  );
};
